import i18next from 'i18next';

export function reloadResources() {
  i18next.reloadResources();
}